import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("fc_token");
    if (!token) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("fc_token");
      })
      .finally(() => setReady(true));
  }, []);

  const persist = (token, u) => {
    localStorage.setItem("fc_token", token);
    setUser(u);
  };

  const register = async ({ name, email, password }) => {
    try {
      const res = await api.post("/auth/register", { name, email, password });
      persist(res.data.token, res.data.user);
      return { user: res.data.user };
    } catch (e) {
      return { error: e.response?.data?.detail || "Registration failed." };
    }
  };

  const login = async ({ email, password }) => {
    try {
      const res = await api.post("/auth/login", { email, password });
      persist(res.data.token, res.data.user);
      return { user: res.data.user };
    } catch (e) {
      return { error: e.response?.data?.detail || "Login failed." };
    }
  };

  const logout = () => {
    localStorage.removeItem("fc_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, register, login, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
